var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCreditcardOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 28,
    fill: "none",
    viewBox: "0 0 30 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7581A5",
    d: "M26.501 2.5h-22a2.729 2.729 0 0 0-2.736 2.75l-.014 16.5a2.74 2.74 0 0 0 2.75 2.75h22a2.74 2.74 0 0 0 2.75-2.75V5.25a2.74 2.74 0 0 0-2.75-2.75Zm-1.375 19.25H5.876a1.38 1.38 0 0 1-1.375-1.374V13.5h22v6.875a1.38 1.38 0 0 1-1.375 1.375ZM26.501 8h-22V6.627c0-.757.619-1.375 1.375-1.375h19.25a1.38 1.38 0 0 1 1.375 1.375V8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FD",
    fillRule: "evenodd",
    d: "M27.977 25.691a1.572 1.572 0 0 1-2.224 0L3.99 3.928a1.572 1.572 0 1 1 2.224-2.223l21.763 21.762c.613.614.613 1.61 0 2.224Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7581A5",
    fillRule: "evenodd",
    d: "M.7 1.528a2 2 0 0 1 2.827 0l22.7 22.7a2 2 0 0 1-2.828 2.828l-22.7-22.7a2 2 0 0 1 0-2.828Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCreditcardOutlined);
export default __webpack_public_path__ + "static/media/icon-creditcard-outlined.2c3a09e2.svg";
export { ForwardRef as ReactComponent };